var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui ui-game"},[_c('GameScore'),_c('footer',{staticClass:"ui-game__footer"},[_c('GameProgressbar'),_c('GameLife')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }